import React from 'react';
import { connect } from 'react-redux';
import { Dialog, DialogContent } from '@mui/material';
import { RotatingLines } from 'react-loader-spinner';

const LoadingView = (props) => {
  return (
    <Dialog open={props.open}>
      <DialogContent>
        <RotatingLines strokeColor='teal' strokeWidth='5' animationDuration='0.75' width='96' visible={true} />
      </DialogContent>
    </Dialog>
  );
};
/** react-redux */
const mapStateToProps = (state) => {
  return {
    open: state.loading.open
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoadingView);